module.exports = "\r\n<h1>{{title}}</h1>\r\n\r\n<h5>You are logged in as: <strong>{{username}}</strong></h5>\r\n\r\n<p>Quote of the day: <span class=\"quote\">{{quote}}</span></p>"


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/sample/containers/sample-banner/sample-banner.html
// module id = ../../../../../src/app/sample/containers/sample-banner/sample-banner.html
// module chunks = main